<template>
  <article
    class="project-teaser"
    @click="loadNode"
  >
    <header class="header">
      <h1 class="heading">
        {{ project.title }}
      </h1>
      <h2 v-if="fieldSubtitle">
        {{ fieldSubtitle }}
      </h2>
    </header>
    <FieldImage
      v-if="fieldImage !== null"
      class="field--name-field-image"
      :field-image="fieldImage"
    />
    <FieldBody
      class="field--name-body"
      :lang="lang"
      :field-body="fieldBody"
      :link-url="linkUrl"
    />
    <FieldTags
      class="field--name-field-tags"
      :lang="lang"
      :field-tags="fieldTags"
    />
  </article>
</template>

<script>
  import FieldImage from './FieldImage.vue'
  import FieldBody from './FieldBody.vue'
  import FieldTags from './FieldTags.vue'
  import LanguageHelper from '../mixins/LanguageHelper.js'

  export default {
    name: 'ProjectsTeaser',
    components: {
      FieldImage,
      FieldBody,
      FieldTags,
    },
    mixins: [LanguageHelper],
    props: {
      project: { type: Object, required: true },
      lang: { type: String, default: 'en' },
    },
    computed: {
      fieldSubtitle() {
        return this.project.fieldSubtitle
      },
      fieldImage() {
        return this.project.fieldImage ? { ...this.project.fieldImage } : null
      },
      fieldBody() {
        return { ...this.project.body }
      },
      fieldTags() {
        return this.project.fieldTags || []
      },
      linkUrl() {
        return this.langPrefix(`/node/${this.project.nid}`)
      },
    },
    methods: {
      // The whole teaser links to the node; real links inside it (tags, "read more")
      // keep their own target.
      loadNode(e) {
        if (!e.target.closest('a')) {
          window.location.href = this.linkUrl
        }
      },
    },
  }
</script>

<style>
  /* Compiled from the theme's %teaser / headings abstractions (compass clearfix and
     breakpoint-sass are not available any more), identical to the previous build. */
  .project-teaser {
    cursor: pointer;
    margin: 2em 0 1em;
    font-size: 1rem;
    overflow: hidden;
  }
  .project-teaser .header {
    font-family: Inconsolata, "Lucida Console", monospace;
    font-size: 1.8em;
    line-height: 1.2;
    background: #e1f0c2;
    padding: .2em;
    color: var(--dm-green-dark, #1c7e35);
    margin: 0 0 .2em;
  }
  .project-teaser .header h1,
  .project-teaser .header h2 {
    margin: 0;
  }
  .project-teaser .header h1 {
    font-size: 1.4em;
    padding-bottom: 0;
  }
  .project-teaser .header h2 {
    font-size: 1em;
    padding-top: .3em;
  }
  .project-teaser .field--name-field-tags {
    color: var(--dm-green-dark, #1c7e35);
  }

  @media (min-width: 48em) {
    .project-teaser {
      margin: 5em auto 3em;
      max-width: 53.75em;
      display: grid;
      grid-gap: 0 5%;
      grid-template-columns: 38.2% 56.8%;
      grid-template-rows: minmax(0, 1fr) auto minmax(0, 1fr);
      padding: 1em 2.5% .5em;
      transition: background-image 1s ease-in-out;
      background-image: radial-gradient(transparent, transparent);
    }
    .project-teaser:hover {
      background-image: radial-gradient(transparent, #e4e4e4);
    }
    .project-teaser .field--name-field-image {
      grid-column: 1 / span 1;
      grid-row: 1 / span 3;
      align-self: center;
      padding: 0;
    }
    .project-teaser .header {
      grid-column-start: 2;
      grid-row-start: 1;
      background: transparent;
      padding: 0;
      font-size: 1rem;
      align-self: flex-end;
    }
    .project-teaser .header h1 {
      font-size: 1.8em;
      padding-bottom: 0;
    }
    .project-teaser .header h2 {
      font-size: 1.2em;
    }
    .project-teaser .field--name-body {
      grid-column-start: 2;
      grid-row-start: 2;
      margin: .5em 0;
    }
    .project-teaser .field--name-field-tags {
      grid-column-start: 2;
      grid-row-start: 3;
      padding: 1em 0 0;
      font-size: .9em;
    }
  }
</style>
